import React from 'react';
import { Navigate } from 'react-router-dom';
 
 
export default function PublicRoute  ({isAuth,  children }) {
    return false ? <Navigate to="/dashboard"/> : children ;
};